/*global DocumentTouch*/

window.o_global = window.o_global || {};

o_global.device = o_global.device || {};

/**
 * Check if Browser is a touchable Device and set root class "touchable" accordingly.
 * PhantomJS is registered as a touchable device incorrectly.
 *
 * Old msMaxTouchPoints returns wrong results at non-touch-devices.
 *
 * @return {Boolean} Flag if device is touchable or not.
 */
o_global.device.isTouchable = (function() {
    "use strict";

    var isTouchable = ((("ontouchstart" in window ||
                        !!(window.DocumentTouch && document instanceof DocumentTouch) ||
                        window.navigator.maxTouchPoints)) && 
                        !window._phantom && !window.phantom) ? true : false;

    if (isTouchable) {
        // Add "touchable" class to root element if device ist definitely touchable.
        document.documentElement.classList.add("touchable");
    } else {
        document.documentElement.classList.add("not-touchable");
    }

    return isTouchable;
}());
